
// Layout components
import { VueConstructor } from 'vue';

import DmsMerge from './components/Merge.vue';
import DmsCard from './components/dms/layout/Card.vue';
import DmsTable from './components/dms/layout/Table.vue';
import DmsPaging from './components/dms/layout/Paging.vue';
import DmsCol from './components/dms/layout/Col.vue';
import DmsColClear from './components/dms/layout/ColClear.vue';
import DmsRow from './components/dms/layout/Row.vue';
import DmsCollapse from './components/dms/layout/Collapse.vue';
import DmsCollapseItem from './components/dms/layout/CollapseItem.vue';
import DmsDialog from './components/dms/layout/Dialog.vue';
import DmsCollapseTable from './components/dms/layout/CollapseTable.vue';
import DmsTabs from './components/dms/layout/Tabs.vue';
import DmsTooltip from './components/dms/layout/Tooltip.vue';
// Form components
import DmsButton from './components/dms/form/Button.vue';
import DmsInfoButton from './components/dms/form/InfoButton.vue';
import DmsInfoInput from './components/dms/form/InfoInput.vue';
import DmsButtonGroup from './components/dms/form/ButtonGroup.vue';
import DmsColorPicker from './components/dms/form/ColorPicker.vue';
import DmsDatePicker from './components/dms/form/DatePicker.vue';
import DmsDropdownButton from './components/dms/form/DropdownButton.vue';
import DmsOdDoDatePicker from './components/dms/form/OdDoDatePicker.vue';
import DmsForm from './components/dms/form/Form.vue';
import DmsFormItem from './components/dms/form/FormItem.vue';
import DmsCheck from './components/dms/form/Check.vue';
import DmsCheckGroup from './components/dms/form/CheckGroup.vue';
import DmsInput from './components/dms/form/input/Input.vue';
import DmsRadio from './components/dms/form/Radio.vue';
import DmsSelect from './components/dms/form/Select.vue';
import DmsMultiSelect from './components/dms/form/MultiSelect.vue';
import DmsSwitch from './components/dms/form/Switch.vue';
import DmsTimePicker from './components/dms/form/TimePicker.vue';
import DmsSelectGrid from './components/dms/form/SelectGrid.vue';
import DmsGroup from './components/dms/form/Group.vue';
import Dms3stateCheck from './components/dms/form/3stateCheck.vue';
import DmsActivity from './components/dms/Activity.vue';
import DmsInputUpload from './components/dms/form/InputUpload.vue';
import DmsInputNumber from './components/dms/form/input/InputNumber.vue';
import DmsLabel from './components/dms/form/Label.vue';
import DmsRichText from './components/dms/form/richText/RichText.vue';
import DmsSlider from './components/dms/form/Slider.vue';
import DmsInputRemoteSearch from './components/dms/form/input/InputRemoteSearch.vue';
import DmsListLayout from './layout/DmsListLayout.vue';
import DmsEditLayout from './layout/DmsEditLayout.vue';
import DmsDiveder from './components/dms/form/divider.vue';
import DmsInputShow from './components/dms/form/InputShow.vue';
import SimpleTable from './components/dms/layout/SimpleTable.vue';
import TableColumn from './components/dms/layout/TableColumn.vue';
import Popover from './components/dms/form/Popover.vue';
import DmsUpload from './components/dms/form/Upload.vue';
import DmsSubstring from './components/dms/form/Substring.vue';
import DmsRadioButton from './components/dms/form/RadioButton.vue';
import DmsCustomIcon from './components/dms/form/CustomIcon.vue';
// Dev components
import DmsDevLocalizationKey from './components/dms/DevLocalizationKey.vue';

export class ComponentsInstaller {
	static install(Vue: VueConstructor) {
		// base dms Components
		Vue.component('DmsButton', DmsButton);
		Vue.component('DmsInfoButton', DmsInfoButton);
		Vue.component('DmsInfoInput', DmsInfoInput);
		Vue.component('DmsButtonGroup', DmsButtonGroup);
		Vue.component('DmsCard', DmsCard);
		Vue.component('DmsColorPicker', DmsColorPicker);
		Vue.component('DmsDatePicker', DmsDatePicker);
		Vue.component('DmsDropdownButton', DmsDropdownButton);
		Vue.component('DmsDateOdDo', DmsOdDoDatePicker);
		Vue.component('DmsForm', DmsForm);
		Vue.component('DmsFormItem', DmsFormItem);
		Vue.component('DmsCheckGroup', DmsCheckGroup);
		Vue.component('DmsCheck', DmsCheck);
		Vue.component('DmsInput', DmsInput);
		Vue.component('DmsRadio', DmsRadio);
		Vue.component('DmsRadioButton', DmsRadioButton);
		Vue.component('DmsSelect', DmsSelect);
		Vue.component('DmsMultiSelect', DmsMultiSelect);
		Vue.component('DmsSwitch', DmsSwitch);
		Vue.component('DmsTable', DmsTable);
		Vue.component('DmsTimePicker', DmsTimePicker);
		Vue.component('DmsSelectGrid', DmsSelectGrid);
		Vue.component('DmsGroup', DmsGroup);
		Vue.component('DmsPaging', DmsPaging);
		Vue.component('DmsCol', DmsCol);
		Vue.component('DmsColClear', DmsColClear);
		Vue.component('DmsRow', DmsRow);
		Vue.component('DmsCollapse', DmsCollapse);
		Vue.component('DmsCollapseItem', DmsCollapseItem);
		Vue.component('DmsDialog', DmsDialog);
		Vue.component('Dms3stateCheck', Dms3stateCheck);
		Vue.component('DmsActivity', DmsActivity);
		Vue.component('DmsInputNumber', DmsInputNumber);
		Vue.component('DmsInputUpload', DmsInputUpload);
		Vue.component('DmsLabel', DmsLabel);
		Vue.component('DmsRichText', DmsRichText);
		Vue.component('DmsSlider', DmsSlider);
		Vue.component('DmsTabs', DmsTabs);
		Vue.component('DmsInputRemoteSearch', DmsInputRemoteSearch);
		Vue.component('DmsMerge', DmsMerge);
		Vue.component('DmsDivider', DmsDiveder);
		Vue.component('DmsInputShow', DmsInputShow);
		Vue.component('DmsPopover', Popover);
		Vue.component('DmsUpload', DmsUpload);
		Vue.component('DmsSubstring', DmsSubstring);
		Vue.component('DmsCustomIcon', DmsCustomIcon);

		// layouts
		Vue.component('DmsListLayout', DmsListLayout);
		Vue.component('DmsEditLayout', DmsEditLayout);
		Vue.component('DmsCollapseTable', DmsCollapseTable);
		Vue.component('DmsTooltip', DmsTooltip);
		Vue.component('DmsSimpleTable', SimpleTable);
		Vue.component('DmsTableColumn', TableColumn);

		// dev
		Vue.component('DmsDevLocalizationKey', DmsDevLocalizationKey);
	}
}
